import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicListItem } from './dynamic-list-item.type';

export interface DynamicListInterface {
  items: DynamicListItem[];
}

@Component({
  selector: 'rd-shared-dynamic-list',
  templateUrl: './dynamic-list.component.html',
  styleUrls: ['./dynamic-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicListComponent implements DynamicListInterface {
  @Input() items: DynamicListItem[];
  @Input() ariaHidden = false;
  @Input() listAriaLabel: string;
}
